import Globals from "./GlobalConstants";
import { AmbrosiaCoursewareItem } from "../interfaces";

export function getAmbrosiaProperty(data: AmbrosiaCoursewareItem, target: string) {
  if (Object.keys(data).length) {
    const newData = { ...data };
    type KeyType = keyof typeof newData;

    if (newData[target as KeyType]) {
      return newData[target as KeyType];
    }
    throw new Error("No target field found");
  }
  throw new Error("No source data found");
}

export const getEncryptedFilesList = (elementId: string): string[] => {
  const tocElement = Globals.tocMap.get(elementId);

  if (!tocElement) {
    throw new Error(`The element Id ${elementId} doesn't exist.`);
  }

  const getFiles = (fileId: string): string[] => {
    let files = window.assets?.[fileId] || [];
    files = files.map((file) => `${Globals.packagePath}/assets/images${file}`);
    files.push(`${Globals.packagePath}/data/${fileId}.js`);

    return files;
  };

  let files: string[] = [];
  tocElement.screens?.forEach((screenId: string) => {
    files = files.concat(getFiles(screenId));
  });

  return files;
};
